import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLang } from '../hooks';
import { getMerchItems, type MerchItem } from '../services/api/merch';
import './MerchPage.css';

export default function MerchPage() {
  const { t } = useTranslation();
  const locale = useLang().lang;
  const [items, setItems] = useState<MerchItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMerchItems()
      .then(setItems)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loading">{t('common.loading')}</div>;

  return (
    <div className="merch-page page">
      <h1 className="merch-page__title">{t('nav.merch')}</h1>
      <div className="merch-page__grid">
        {items.map((item) => {
          const title = locale === 'th' && item.title_th ? item.title_th : item.title_en;
          return (
            <a
              key={item.id}
              href={item.shopify_url}
              target="_blank"
              rel="noopener noreferrer"
              className="merch-card"
            >
              {item.image_url && <img src={item.image_url} alt="" className="merch-card__image" />}
              <div className="merch-card__body">
                <p className="merch-card__title">{title}</p>
                <span className="merch-card__cta">View / Buy →</span>
              </div>
            </a>
          );
        })}
      </div>
      {items.length === 0 && <p className="page-empty">No merch yet.</p>}
    </div>
  );
}
